module.exports = __webpack_public_path__ + "static/media/lg-logo.1b4620f5.svg";